// Third Party Library
import { useState, useEffect } from "react";
import { Dropdown, message } from "antd";
import { useSelector, useDispatch } from "react-redux";

// Constants Library
import { TEMPLATE } from "../../../../../../constants";

// Components Library
import { TableList, ButtonLink, DrawerRemark } from "../../../../../../components";
import { ActionItems } from "./actions";

// Handler Library 
import { tableHDLR, filter } from "../../../../../../handlers";

// Services Library
import { REDUX as REDUX_UTIL } from "../../../../../../services/util";

// Styles Library

const { PAYROLL_SUMMARY_COL } = TEMPLATE.TABLEDATA.PAYROLL;
const { reduxStoreWrapper } = REDUX_UTIL;
const { PAYROLL_STATUS_TITLE } = TEMPLATE.PAYROLL;

const TablePayroll = (props) => {
  const {
    source,
    filteredData,
    paginatedData,
    tabKey,
    setFilteredData,
    selectedRow,
    setSelectedRow,
    selectedRowKeys,
    setSelectedRowKeys,
    isPending,
    setIsPending,
    isClicked,
    setIsClicked
  } = props;
  const dispatch = useDispatch();
  console.log(selectedRow, "source payroll")

  const [messageApi, contextHolder] = message.useMessage();

  const [tabStatus, setTabStatus] = useState({});
  const [isOpenRemark, setIsOpenRemark] = useState(false);
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const [data, setData] = useState({});
  const [originalData, setOriginalData] = useState([]);
  const [isData, setIsData] = useState(false);

  const user = useSelector(reduxStoreWrapper("user"));
  const company = useSelector(reduxStoreWrapper("company.byID"));
  const loading = useSelector(reduxStoreWrapper("style.loading.payroll"));


  useEffect(() => {
    if (originalData?.length === 0 && !isData && filteredData[tabKey]?.length) {
      setOriginalData(filteredData[tabKey]);
      setIsData(true)
    }
  }, [filteredData, isData, tabKey]);

  const filterData = (data) =>
    filter.filterHDLR.tableData(
      data,
      filteredInfo,
      sortedInfo,
    );

  useEffect(() => {
    const filteredAndSortedData = filterData(source);
    
    console.log(filteredAndSortedData, "filteredAndSortedData")

    if (tabStatus[tabKey] && filteredAndSortedData.length !== 0) {
      setFilteredData(filteredAndSortedData);
    }
  }, [tabKey, tabStatus[tabKey], sortedInfo, filteredInfo]);


  const handleTableChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
    setTabStatus((prev) => ({
      ...prev,
      [tabKey]: true,
    }));
  };

  const handleSearch = (_, confirm) => {
    confirm();
  };

  const columns = [
    ...PAYROLL_SUMMARY_COL({
      redux: {
        user,
        company
      },
      func: {
        handleSearch,
        DrawerRemark: (data) => {
          setIsOpenRemark(true);
          setData(data);
        },
      },
    }),
    {
      title: "Actions",
      width: 100,
      fixed: "right",
      render: (_, record) => {
        return (
          <Dropdown
            menu={{
              items: ActionItems(
                record,
                setData,
                setIsOpenRemark,
                user,
                dispatch,
                messageApi
              ),
            }}
          >
            <ButtonLink>Actions</ButtonLink>
          </Dropdown>
        );
      },
    },
  ];

  const onSelectRow = (record, selected) => {
    tableHDLR.selectRow(
      setSelectedRowKeys,
      setSelectedRow,
      selectedRow,
      selectedRowKeys,
      record,
      selected
    );
  };

  const onSelectAllRows = (selected, selectedRows, changeRows) => {
    tableHDLR.selectAllRows(
      setSelectedRowKeys,
      setSelectedRow,
      selectedRow,
      selectedRowKeys,
      changeRows,
      selected,
    );
  };

  useEffect(() => {
    if (isPending && filteredData && !isClicked){
      const selectChange = filteredData.filter(f => filteredData.map(f => f.prid).includes(f.prid))
      setSelectedRowKeys(filteredData.map(f => f.prid))
      setSelectedRow(selectChange);
    } else if(!isPending) {
      setSelectedRowKeys(selectedRowKeys)
    } 
    if(isClicked && selectedRowKeys.length){
      setIsPending(false)
      setIsClicked(false)
      setSelectedRow([])
      setSelectedRowKeys([])
    } 
  }, [isPending, isClicked, filteredData, selectedRowKeys]);

  const rowSelection = {
    selectedRowKeys: selectedRowKeys,
    onSelect: onSelectRow,
    onSelectAll: onSelectAllRows,
  };

  return (
    <>
      {contextHolder}
      <DrawerRemark
        isOpen={isOpenRemark}
        setIsOpen={setIsOpenRemark}
        refid={data.prid}
        statusData={PAYROLL_STATUS_TITLE}
        memid={data?.prid}
      />
      <TableList.DataList
        paginatedData={paginatedData}
        columnData={columns}
        rowSelection={rowSelection}
        onChange={handleTableChange}
        loading={loading}
      />
    </>
  );
};

export default TablePayroll;